<table #table [id]="tableName" [style.overflowX]="overflow.x" [style.overflowY]="overflow.y" [style.height]="'calc(100% - ' + heightOffset + 'px)'">
  <div class="loading" *ngIf="loading">
    <mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner>
  </div>
  <thead>
    <tr>
      <th [ngClass]="{'noSearch' : searchDisabled}" class="row-actions" *ngIf="multiselect">
        <button mat-icon-button [matMenuTriggerFor]="actions" *ngIf="multiselectActions.any()">
          <mat-icon>more_vert</mat-icon>
        </button>
      </th>
      <th [draggable]="!isActiveElement(tableHeader)" data-drop-effect="all" (dragstart)="$event.dataTransfer.setData('text','')" (dragend)="moveColumn(index, $event)"
        (dragover)="tableHeader.classList.add('dragover'); dragOverElement = tableHeader;" (dragleave)="tableHeader.classList.remove('dragover')"
        class="table-header" #tableHeader *ngFor="let displayColumn of displayColumns; let index = index;">
        <span (click)="sort(displayColumn, $event)">{{displayColumn.title}}</span>
        <mat-icon class="sort" *ngIf="sortColumn == displayColumn && sortColumn?.sortDirection == 1">arrow_upward</mat-icon>
        <mat-icon class="sort" *ngIf="sortColumn == displayColumn && sortColumn?.sortDirection == 2">arrow_downward</mat-icon>
        <div (mousedown)="resize(tableHeader, index, $event)" class="resize-column"></div>
        <div [draggable]="false" (dragstart)="$event.preventDefault();$event.stopPropagation()" (dragend)="$event.stopPropagation()" *ngIf="!searchDisabled" class="input-container">
          <input autocomplete="off" (keyup.enter)="keyupEnter.emit(filteredEntities[arrowIndex + (viewPageSize*pageIndex)])" (keydown)="handleArrows($event)" #searchInput [draggable]="false" (focus)="searchInput.select()" (dragstart)="$event.preventDefault();$event.stopPropagation()" (dragend)="$event.stopPropagation()" [(ngModel)]="displayColumn.searchText" (ngModelChange)="search();">
          <mat-icon *ngIf="!displayColumn.searchText?.length">search</mat-icon>
          <mat-icon class="pointer" (click)="displayColumn.searchText = null; search();" *ngIf="displayColumn.searchText?.length">clear</mat-icon>
        </div>
      </th>
      <th [ngClass]="{'noSearch' : searchDisabled}"></th>
    </tr>
  </thead>
  
  <tbody>
    <tr (click)="setFilteredEntity(filteredEntity,$index + (viewPageSize*pageIndex))" (dblclick)="rowDblClick.emit(filteredEntity)" #tableRow
      *ngFor="let filteredEntity of displayedEntities; let $index = index;">
      <td class="row-actions" *ngIf="multiselect" (click)="$event.stopPropagation();"><input [disabled]="!canSelectEntities() && !selected[$index + (viewPageSize*pageIndex)]" [(ngModel)]="selected[$index + (viewPageSize*pageIndex)]"
          (ngModelChange)="selectEntities()" type="checkbox"></td>
      <td *ngFor="let displayColumn of displayColumns; let $column = index">
        <input autocomplete="off"
          #editableInput
          numbersOnly
          min="0"
          class="user-input"
          [tabIndex]="($column+1)*viewPageSize+$index+1"
          (click)="$event.stopPropagation();" 
          (focus)="activeInputElement.emit(filteredEntity);" 
          (dblclick)="$event.stopPropagation()" 
          *ngIf="editable && displayColumn.editable && !displayColumn.options?.any()" [type]="displayColumn.type" (keyup.enter)="editEntity(filteredEntity,displayColumn.property,editableInput.value)" 
          (focusout)="editEntity(filteredEntity,displayColumn.property,editableInput.value)" [value]="getProperty(filteredEntity,displayColumn.property)">
        <span *ngIf="!editable || !displayColumn.editable || displayColumn.options?.any()">{{getProperty(filteredEntity,displayColumn.property)}}</span>
      </td>
      <ng-container *ngIf="showDeleteKeySystem">
        <!-- Feature flag controls who can access (role-based), business logic controls when (ownership) -->
        <td *featureFlag="'DELETE_KEYSYSTEM'">
          <button mat-icon-button (click)="$event.stopPropagation(); deleteKeySystem(filteredEntity)">
            <mat-icon title="Delete Key System">delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>
    </tr>
  </tbody>

</table>

<mat-menu #actions="matMenu">
  <button mat-menu-item [disabled]="action.enabled ? !action.enabled() : false" *ngFor="let action of multiselectActions" (click)="action.callback()">{{action.name}}</button>
</mat-menu>

<mat-paginator
  class="paginator"
  *ngIf="pagination"
  [length]="filteredEntities.length"
  [pageSize]="viewPageSize"
  (page)="pageIndex = $event.pageIndex; setDisplayEntities(); arrowIndex = -1;">
</mat-paginator>
